import React from "react";
import { scoreBand } from "@/lib/motives";

/**
 * Panini-style trading card for a player archetype.
 * archetype: {name, tagline, description, top_motives, gradient}
 * scores: dict
 */
export default function PlayerCard({ archetype, player, teamName }) {
  const [c1, c2] = archetype.gradient || ["#CCFF00", "#00F0FF"];
  return (
    <div
      data-testid="player-trading-card"
      className="relative overflow-hidden rounded-lg border border-[#CCFF00]/40 p-8 min-h-[380px] flex flex-col"
      style={{
        background: `radial-gradient(ellipse at top left, ${c1}22 0%, transparent 60%), radial-gradient(ellipse at bottom right, ${c2}22 0%, transparent 60%), linear-gradient(180deg, #1a1c20 0%, #050505 100%)`,
      }}
    >
      {/* Corner badge */}
      <div className="absolute top-4 right-4">
        <div className="font-display text-[10px] tracking-widest text-white/40">
          FMP<sup>&reg;</sup> / SPIELERTYP
        </div>
      </div>

      {/* Pattern overlay */}
      <div className="absolute inset-0 pitch-lines opacity-20 pointer-events-none" />

      <div className="relative z-10 flex flex-col h-full">
        {teamName && (
          <div className="font-display text-xs tracking-[0.2em] text-white/50 mb-2">
            {teamName}
          </div>
        )}
        <h1
          data-testid="player-name-heading"
          className="font-heading font-black text-3xl md:text-4xl leading-none tracking-tight mb-2"
        >
          {player?.name}
        </h1>
        {player?.position && (
          <div className="text-sm text-white/60 mb-6 font-medium">
            {player.position}
          </div>
        )}

        <div className="flex-1 flex flex-col justify-end">
          <div
            className="font-heading font-black text-5xl md:text-6xl tracking-tight leading-[0.9]"
            style={{ color: c1 }}
            data-testid="player-archetype-name"
          >
            {archetype.name}
          </div>
          <div className="font-display text-sm tracking-widest text-white/80 mt-3">
            {archetype.tagline}
          </div>
          <p className="text-sm text-white/70 mt-4 leading-relaxed max-w-md">
            {archetype.description}
          </p>

          <div className="flex gap-2 mt-6">
            {archetype.top_motives?.map((slug) => (
              <span
                key={slug}
                className="font-display text-[10px] tracking-widest px-2.5 py-1 border border-white/20 rounded-sm text-white/70"
              >
                {slug.replace("_", " ")}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
